import { useEffect } from 'react'

/**
 * Open overlays, oldest first. The sub-dealer form opens on top of the dealer
 * panel, and without a stack a single Escape would collapse both layers.
 */
const stack: symbol[] = []

/**
 * Locks background scrolling and closes on Escape, but only when this overlay
 * is the topmost one.
 */
export function useOverlay(open: boolean, onClose: () => void): void {
  useEffect(() => {
    if (!open) return

    const token = Symbol('overlay')
    stack.push(token)

    const onKeyDown = (event: KeyboardEvent): void => {
      if (event.key !== 'Escape') return
      if (stack[stack.length - 1] !== token) return
      event.stopPropagation()
      onClose()
    }

    document.addEventListener('keydown', onKeyDown)
    const previousOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'

    return () => {
      document.removeEventListener('keydown', onKeyDown)
      const index = stack.lastIndexOf(token)
      if (index !== -1) stack.splice(index, 1)
      document.body.style.overflow = previousOverflow
    }
  }, [open, onClose])
}
